import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import axios from 'axios';
import { api } from "../api";

const AlterarSenhaModal = ({ visible, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('access_token');
      await api.post(
      "/api/responsaveis/alterar-senha",
      {
          senha_atual: values.senha_atual,
          senha_nova: values.senha_nova
        },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      message.success('Senha alterada com sucesso!');
      form.resetFields();
      if (onSuccess) {
        onSuccess();
      }
      onClose();
    } catch (error) {
      console.error('Erro ao alterar senha:', error);
      if (error.response?.data?.detail) {
        message.error(error.response.data.detail);
      } else {
        message.error('Erro ao alterar senha');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Alteração de Senha Obrigatória"
      open={visible}
      onCancel={null}
      closable={false}
      footer={null}
      maskClosable={false}
    >
      <div style={{ marginBottom: 20 }}>
        <p>
          <strong>Este é seu primeiro acesso.</strong>
        </p>
        <p>
          Por segurança, você precisa alterar sua senha temporária antes de continuar.
        </p>
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          label="Senha Atual (Temporária)"
          name="senha_atual"
          rules={[
            { required: true, message: 'Digite a senha temporária' },
            { min: 6, message: 'Senha deve ter no mínimo 6 caracteres' }
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Digite a senha temporária recebida"
            autoFocus
          />
        </Form.Item>

        <Form.Item
          label="Nova Senha"
          name="senha_nova"
          rules={[
            { required: true, message: 'Digite sua nova senha' },
            { min: 6, message: 'Senha deve ter no mínimo 6 caracteres' }
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Digite sua nova senha"
          />
        </Form.Item>

        <Form.Item
          label="Confirmar Nova Senha"
          name="confirmar_senha"
          dependencies={['senha_nova']}
          rules={[
            { required: true, message: 'Confirme sua nova senha' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('senha_nova') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('As senhas não coincidem'));
              },
            }),
          ]}
        >
          <Input.Password
            prefix={<LockOutlined />}
            placeholder="Confirme sua nova senha"
          />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            block
            size="large"
          >
            Alterar Senha
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AlterarSenhaModal;
